import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { SortType } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { IInventoryRepository } from '@/coreInfrastructureModule/interfaces/IInventoryRepository';
import { InventoryAdapter } from '../adapters/InventoryAdapter';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { FilterContentItem, FreeColumnFilterContentItem } from '@/corePagesModule/filterModal/filterModal';

/**
 * 在庫管理ページに必要な取引情報を取得する
 */
export class GetInventoryBusinessUseCase {
  private repository: IInventoryRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IInventoryRepository) {
    this.repository = repository;
  }

  /**
   * 在庫情報の取得
   * @param aggregateBusinessId - 組織ID
   * @param sortType - ソートタイプ
   * @param limit - 取得件数
   * @param offset - 取得開始位置
   * @param earlyPeriod - 表示期間の開始日
   * @param latterPeriod - 表示期間の終了日
   * @param filterItems - フィルターの一覧
   * @param freeColumnFilterItems - 自由欄フィルターの一覧
   */
  public async execute(
    aggregateBusinessId: string,
    sortType: SortType,
    limit: number,
    offset: number,
    earlyPeriod: string,
    latterPeriod: string,
    filterItems: FilterContentItem[],
    freeColumnFilterItems: FreeColumnFilterContentItem[] = []
  ): Promise<INetworkResult<IBusiness[], IError>> {
    // フロント側から指定されたフィルターをリクエスト用の形式に変換
    const [filterItem, filterInfoItem] = FilterService.convertFilterObjectWithInfo(filterItems);
    const { baseFreeColumns } = FilterService.convertFreeColumnFilterItems(freeColumnFilterItems);
    const networkResult = await this.repository.getBusiness(
      sortType,
      limit,
      offset,
      aggregateBusinessId,
      earlyPeriod,
      latterPeriod,
      filterInfoItem,
      filterItem,
      'customerForecast,salesResult',
      baseFreeColumns
    );
    switch (networkResult.status.type) {
      case 'success':
        return { status: { type: 'success', data: InventoryAdapter.adaptBusiness(networkResult.status.data.result) } };
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
